import { FC, Dispatch } from "react";
import { StandardHandler } from "../../../middleware/handlers/standard-handler";
import type {
  MeasureTool,
  MeasureUnits,
} from "../../../core/standard/viewer-tools";

interface MeasureMenuProps {
  measurePanelReveal: boolean;
  measureTool: MeasureTool;
  setMeasureTool: Dispatch<MeasureTool>;
  measureUnits: MeasureUnits;
  setMeasureUnits: Dispatch<MeasureUnits>;
}

// how each measurement is drawn; the viewer listens for the gestures named
const measureTools: { tool: MeasureTool; label: string; hint: string }[] = [
  {
    tool: "LENGTH",
    label: "Length",
    hint: "Double-click two points.",
  },
  {
    tool: "AREA",
    label: "Area",
    hint: "Double-click each corner, then press Enter.",
  },
  {
    tool: "ANGLE",
    label: "Angle",
    hint: "Double-click a start point, the vertex, then an end point.",
  },
  {
    tool: "VOLUME",
    label: "Volume",
    hint: "Double-click each element to include, then press Enter.",
  },
];

const measureUnitOptions: { units: MeasureUnits; label: string }[] = [
  { units: "IMPERIAL", label: "Imperial" },
  { units: "METRIC", label: "Metric" },
];

export const MeasureMenu: FC<MeasureMenuProps> = ({
  measurePanelReveal,
  measureTool,
  setMeasureTool,
  measureUnits,
  setMeasureUnits,
}) => {
  if (!measurePanelReveal) return null;

  return (
    <div className="viewerToolPanel">
      <div className="viewerToolPanelHeader">
        <span className="viewerToolPanelLabel">MEASURE</span>
        <span className="viewerToolPanelName">Pick what to measure</span>
        <div className="viewerToolUnits">
          {measureUnitOptions.map(({ units, label }) => (
            <input
              key={units}
              type="button"
              value={label}
              className={
                units === measureUnits
                  ? "viewerToolUnit viewerToolUnitSelected"
                  : "viewerToolUnit"
              }
              onClick={() => {
                setMeasureUnits(units);
              }}
            />
          ))}
        </div>
      </div>
      <div className="viewerToolRowWrapper">
        {measureTools.map(({ tool, label, hint }) => (
          <div
            key={tool}
            className={
              tool === measureTool
                ? "viewerToolRow viewerToolRowSelected"
                : "viewerToolRow"
            }
            onClick={() => {
              setMeasureTool(tool);
            }}
          >
            <span className="viewerToolRowLabel">{label}</span>
            <span className="viewerToolRowHint">{hint}</span>
          </div>
        ))}
      </div>
      <div className="viewerToolPanelFooter">
        <span>
          Hover a measurement and press Delete to remove it. Esc cancels the one
          being drawn.
        </span>
        <input
          type="button"
          value="Clear all measurements"
          onClick={() => {
            StandardHandler.ClearMeasurements();
          }}
        />
      </div>
    </div>
  );
};

export default MeasureMenu;
